export const BLACK = 'black'
export const WHITE = 'white'
export const DARK_TEXT_COLOUR = '#343a40'
export const LIGHT_TEXT_COLOUR = WHITE
export const BASE_BUBBLE_OPACITY = 0.25
